export const autoCashoutHelper = (
  round: any,
  isMybetInList: boolean,
  isAutoOn: any,
  isCashouted: boolean,
  cashoutAt: string,
  stake: any,
  betsRemained: number,
  setisMybetInList: (a: boolean) => void,
  stopAuto: (a: boolean) => void,
  setisCashouted: (a: boolean) => void,
  sethasJustPlaced: any,
) => {
  if (isAutoOn) {
    if (round.state === 2) {
      if (!isCashouted && isMybetInList) {
        let stk: number = round.value * stake
        if (stk >= +cashoutAt) {
          setisCashouted(true)
          if (betsRemained === 0) {
            setisMybetInList(false)
            stopAuto(false)
          }
        }
        return
      }
      if (!isCashouted) {
        sethasJustPlaced(true)
      }
    }
  }
}
